export enum FeaturePermissionTitle {
  // Letters
  groupList = 'Group',
  groupItem = 'Group',
  submissionItem = 'Own template',
  submissionSample = '#sample',
  submissionCommon = 'Common template',
  submissionList = 'submissionList',
  submissionPrivate = 'Private template',
  templateEditor = 'Sample editor',
  // Answers
  answerTable = 'Answer management',
  answerItem = 'Answer',
  // Dashboard
  managementUsers = 'User management',
  managementUnits = 'Unit management',
  managementRoles = 'managementRoles',
  // Roles
  rolePermissions = 'Permission management',
  roleItem = 'Role management',
}
